// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"420b64bf","732":"da0ee32f","977":"b0c2a431"}[chunkId] + ".chunk.js";
};